import { Box, Typography, Grid, Card } from '@mui/material'
import React, { useEffect, useState } from 'react'
import Divider from '@mui/material/Divider'
import styled from 'styled-components'
import Web3 from 'web3'
import Contract from '../../Contract'
import Graph from '../Graph/Graph'
import './Detailsbox.css'
import Connection from '../../Contract'
import { ethers } from 'ethers'

// import axios from 'axios';

const StyledBox = styled(Box)`
  text-align: center !important;
  border-radius: 20px;
  color: #fffff9 !important;
  background: #2c2e3f !important;
  margin: 0.5rem !important;
  padding: 4rem 2rem !important;
  @media (max-width: 600px) {
    padding: 2rem 0rem !important;
  }
`

const DetailsBox = () => {
  const [currentBlockNumber, setCurrentBlock] = React.useState()
  const [votingPower, setVotingPower] = useState()
  const [toggleState, setToggleState] = useState(true)
  const [getApiDat, setApiData] = useState()
  const [toggleApiHandle, setToggleApiHandle] = useState(true)
  const [apiTotal, setApiTotal] = useState()
  const [hightCount, setHighestCount] = useState()
  const [highestValidatorCounts, setHighestValidatorCounts] = useState('0')
  const [getVotingPower, setTotalVotingPower] = useState(0)

  const web3 = new Web3()

  web3.setProvider('https://rpc.Dexit.network')

  const getLatestBlockNumber = async () => {
    try {
      let contract = await Contract.totalDXTStake()
      setVotingPower(contract.toString())
      let currentBlock = await web3.eth.getBlockNumber()
      setToggleState(!toggleState)
    } catch (error) {
      console.log(error)
    }
  }

  const getTransactionCounts = async () => {
    var requestOptions = {
      method: 'GET',
      redirect: 'follow',
    }

    fetch('https://api.Dexit.network/blockstransactions', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        // console.log(JSON.parse(result))
        setApiData(JSON.parse(result))

        blockTransactionCount(JSON.parse(result))

        setToggleApiHandle(!toggleApiHandle)
      })
      .catch((error) => console.log('error', error))
  }

  const postTransactionCounts = (blocknum, totalCount) => {
    var myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')

    var raw = JSON.stringify({
      count: totalCount,
      start: blocknum,
    })

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    }

    fetch(
      'https://api.Dexit.network/transactioncountupdate/1',
      requestOptions,
    )
      .then((response) => response.text())
      .then((result) => console.log(result))
      .catch((error) => console.log('error', error))
  }

  useEffect(() => {
    getTransactionCounts()
    getCurrentBlockFunction()
    getLatestBlockNumber()
  }, [])

  const getCurrentBlockFunction = async () => {
    try {
      let blocknumber = await web3.eth.getBlockNumber()
      setCurrentBlock(blocknumber)
    } catch (error) {
      console.log(error)
    }
  }

  async function getBalanceData() {
    try {
      let list = await Connection.getHighestValidators()
      setHighestCount(list.length)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    clearInterval(id)
  }, [])

  const id = setInterval(() => {
    getTransactionCounts()
  }, 60000 * 5)

  const blockTransactionCount = async (result) => {
    try {
      let counter = result.data[0].count
      setApiTotal(counter)
      let currentBlock = await web3.eth.getBlockNumber()
      let counterTsx = await web3.eth.getBlockTransactionCount(currentBlock)
      let total = counterTsx + counter
      setApiTotal(counter + counterTsx)
      postTransactionCounts(currentBlock, total)
    } catch (error) {
      console.log(error)
    }
  }

  const [currentPrice, setCurrentPrice] = useState()
  const [dilutedmarketCap, setDilutedMarketCap] = useState()
  const [
    priceChangePercentage30Days,
    setPriceChangePercentage30Days,
  ] = useState()

  async function fetchDXTDetails() {
    const response = await fetch(
      'https://api.coingecko.com/api/v3/coins/dexit-finance',
    )
    if (response.status === 200) {
      const res = await response.json()
      setCurrentPrice(res.market_data.current_price.usd)
      setDilutedMarketCap(res.market_data.fully_diluted_valuation.usd)
      setPriceChangePercentage30Days(
        res.market_data.price_change_percentage_30d,
      )
    }
  }

  const validatorsCount = async () => {
    // try {
    //   let list = await Connection.getHighestValidators()
    //   setHighestValidatorCounts(list.length.toString())
    // } catch (error) {
    //   console.log(error)
    // }

    var requestOptions = {
      method: 'GET',
      redirect: 'follow',
    }

    fetch(
      'https://api.Dexit.network/getHighestValidators',
      requestOptions,
    )
      .then((response) => response.text())
      .then((result) => {
        // console.log(JSON.parse(result),"api result get")
        setHighestValidatorCounts(JSON.parse(result).data)
      })
      .catch((error) => console.log('error', error))
  }

  const totalVotingPower = async () => {
    // try {
    //   let list = await Connection.getCurrentValidators()
    //   let totalVotingPowerAsync = 0
    //   if (list) {
    //     for (let i = 0; i < list.length; i++) {
    //       let dataget = await Connection.getValidatorInfo(list[i])
    //       totalVotingPowerAsync =
    //         totalVotingPowerAsync + Number(dataget[3]) / 1000000000000000000
    //     }
    //     setTotalVotingPower(totalVotingPowerAsync)
    //   }
    // } catch (error) {
    //   console.log(error)
    // }

    var requestOptions = {
      method: 'GET',
      redirect: 'follow',
    }
    fetch('https://api.Dexit.network/getvotingpower', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        // console.log(result,"result")
        setTotalVotingPower(JSON.parse(result).data.slice(0, -18))
      })
      .catch((error) => console.log('error', error))
  }

  useEffect(() => {
    totalVotingPower()
    validatorsCount()
    getBalanceData()
    fetchDXTDetails()
  }, [])

  return (
    <>
      {/* {getApiDat ? ( */}
      <>
        {/* <Grid xs={12} item sm={12} md={4} sx={{ p: 4 }}>
            <Typography>DeXit Network Price (DXT)</Typography>
            <Typography sx={{ mb: 2 }}>
              ${currentPrice ? currentPrice : 'loading'}
            </Typography>

            <Typography>PRICE CHANGE PERCENTAGE 30 DAYS</Typography>
            <Typography sx={{ mb: 2 }}>
              {priceChangePercentage30Days
                ? priceChangePercentage30Days
                : 'loading'}
              %
            </Typography>
            <Divider />
            <Typography>Fully Diluted Market Cap</Typography>

            <Typography sx={{ mb: 2 }}>
              {' '}
              ${dilutedmarketCap ? dilutedmarketCap : 'loading'}
            </Typography>
          </Grid> */}

        <Grid container p={1}>
          <Grid item md={3} xs={6}>
            <StyledBox>
              <Typography>DXT Price</Typography>
              <Typography sx={{ fontSize: { lg: '36px', xs: '28px' } }}>
                ${currentPrice ? currentPrice : 'loading'}
              </Typography>
            </StyledBox>
          </Grid>
          <Grid item md={3} xs={6}>
            <StyledBox>
              <Typography>Latest Block</Typography>
              <Typography sx={{ fontSize: { lg: '36px', xs: '28px' } }}>
                {currentBlockNumber ? currentBlockNumber : '-'}
              </Typography>
            </StyledBox>
          </Grid>
          <Grid item md={3} xs={6}>
            <StyledBox>
              <Typography>Active Validators</Typography>
              {/* <Typography>{hightCount ? hightCount: "0"}</Typography> */}
              <Typography sx={{ fontSize: { lg: '36px', xs: '28px' } }}>
                {highestValidatorCounts !== '0' ? highestValidatorCounts : '0'}
              </Typography>
            </StyledBox>
          </Grid>
          <Grid item md={3} xs={6}>
            <StyledBox>
              <Typography>Voting Power</Typography>
              <Typography sx={{ fontSize: { lg: '36px', xs: '28px' } }}>
                {/* {votingPower ? votingPower.slice(0, -18) : '0'} */}
                {getVotingPower !== 0 ? getVotingPower : '0'}
              </Typography>
            </StyledBox>
          </Grid>
          {/* <Grid item md={3} xs={6}>
              <StyledBox>
                <Typography>Transaction</Typography>
                <Typography sx={{ fontSize: { lg: '36px', xs: '28px' } }}>
                  {getApiDat ? apiTotal : '0'}
                </Typography>
              </StyledBox>
            </Grid> */}
        </Grid>

        {/* <Grid xs={12} item sm={12} md={4} sx={{ p: 4 }}>
              <Graph />
            </Grid> */}
      </>
      {/* ) : (
        <div style={{ textAlign: 'center' }}>loading</div>
      )} */}
    </>
  )
}

export default DetailsBox
